import { useContext, useEffect } from "react";
import { IGenericProps } from "./Generic.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { useGetLegal } from "../../shared/hooks/useGetLegal";
import { DEFAULT_LANGUAGE } from "../../shared/constants";
import { markdownToHtml } from "../../shared/helpers/utils";

const Generic = (props: IGenericProps) => {
    const { lang } = useContext(TranslationContext);

    const { data, refetch: getLegal } = useGetLegal(lang ?? DEFAULT_LANGUAGE, {
        enabled: false
    });

    useEffect(() => {
        const type = props.type;

        switch (type) {
            case "legal":
                getLegal();
                break;

            default:
                break;
        }
    }, [props]);

    return (
        <section
            className="px-1 py-22 px-md-31 pb-22 rich_text text-bd1-md"
            dangerouslySetInnerHTML={{
                __html: data?.success ? markdownToHtml(data.data) : ""
            }}></section>
    );
};

export default Generic;
